import { getDialplanService } from "@ntconnect/framework/pbx";

export const fetchDialplans = (domain, page, pageSize, search) =>
  getDialplanService().fetchDialplans(domain, page, pageSize, search);

export const fetchDialplan = (domain, id) =>
  getDialplanService().fetchDialplan(domain, id);

export const createDialplan = (domain, params) =>
  getDialplanService().createDialplan(domain, params);

export const updateDialplan = (domain, id, params) =>
  getDialplanService().updateDialplan(domain, id, params);

export const deleteDialplan = (domain, id) =>
  getDialplanService().deleteDialplan(domain, id);

export const fetchDialplanDestinations = (domain, dialplanId, page, pageSize) =>
  getDialplanService().fetchDestinations(domain, dialplanId, page, pageSize);

export const createDialplanDestination = (domain, dialplanId, params) =>
  getDialplanService().createDestination(domain, dialplanId, params);

export const updateDialplanDestination = (domain, dialplanId, destId, params) =>
  getDialplanService().updateDestination(domain, dialplanId, destId, params);

export const deleteDialplanDestination = (domain, dialplanId, destId) =>
  getDialplanService().deleteDestination(domain, dialplanId, destId);
